import React from "react";
import { Checkbox as CheckboxAntd, Tooltip } from "antd";
// import CheckboxGroup from "./CheckboxGroup";
import classNames from "classnames";
import "./Checkbox.scss";
import { CommonService } from "@Services/common-service";

export interface CheckboxProps {
  /**Handle change value checkbox */
  onChange?: (value: boolean) => void;
  /**Specifies whether the checkbox is selected */
  checked?: boolean;
  /**True to not allow change value */
  disabled?: boolean;
  /**Label of this checkbox item */
  label?: string;
  /**Type read only is true */
  readOnly?: boolean;
  /**Max length of label checkbox */
  maxLengthItem?: number;
  /**The indeterminate checked state of checkbox */
  indeterminate?: boolean;
}

function Checkbox(props: CheckboxProps) {
  const {
    onChange,
    checked,
    disabled,
    label,
    readOnly,
    maxLengthItem,
    indeterminate,
  } = props;
  const handleChange = React.useCallback(
    (value: any) => {
      if (onChange && typeof onChange === "function") {
        return onChange(value.target.checked);
      }
      return;
    },
    [onChange]
  );

  return (
    <div
      className={classNames("checkbox__container", {
        "read-only": readOnly,
      })}
    >
      <CheckboxAntd
        indeterminate={indeterminate}
        checked={checked}
        onChange={handleChange}
        disabled={disabled || readOnly}
      >
        {maxLengthItem && label?.length > maxLengthItem ? (
          <Tooltip title={label}>
            {CommonService.limitWord(label, maxLengthItem)}
          </Tooltip>
        ) : (
          label
        )}
      </CheckboxAntd>
    </div>
  );
}

export default Checkbox;
